/* @flow */

import * as React from "react";
import { Checkbox } from "react-bootstrap";

// A boolean facet.
export function FacetCheckbox(props: {
    name: string;
    amount: number;
    selected?: boolean;
    onChange: (x0: boolean) => void;
    className?: string; // currently only for testing, not actually applied
}) {
    const testClass = props.selected ? "test-facet-checkbox-selected" : "test-facet-checkbox";
    return (
        <Checkbox className={testClass} checked={props.selected} onChange={() => props.onChange(!props.selected)}>
            <span className="ex-facet-checkbox-text">{props.name + " (" + props.amount + ")"}</span>
        </Checkbox>
    );
}
